export type FeatureFlag<Key extends string> = {
  key: Key;
  description: string;
  createdAt?: `${string}/${string}/${string}`;
};

export const featureFlags = [
  {
    key: 'additionalSchedulingOptions',
    description:
      'Allow the usage of additional monthly scheduling options for audiences on the export modal',
  },
  {
    key: 'allowAdvancedDelay',
    description: '',
  },
  {
    key: 'audienceGraphs',
    description: 'Audience show Demographics tab and related graph UI',
    createdAt: '2026/04/02',
  },
  {
    key: 'audienceCustomGraphs',
    description: 'Audience profile custom reports UI',
    createdAt: '2026/05/04',
  },
  {
    key: 'audienceComparison',
    description: 'Audience profile comparison UI',
    createdAt: '2026/07/09',
  },
  {
    key: 'editableAudiences',
    description: 'Enable editable exported and journey entry audiences UI',
    createdAt: '2026/07/20',
  },
  {
    key: 'audienceScheduleOnExportModal',
    description:
      'Allow the usage of scheduling feature for audiences on the export modal',
  },
  {
    key: 'enhancedMatchRate',
    description: 'Show enhanced match rate option on export v2',
  },
  {
    key: 'useUid2',
    description:
      'Show the Use UID2 toggle on supported (TTD) destination exports',
    createdAt: '2026/06/30',
  },
  {
    key: 'hasDelayMinutes',
    description: 'Add minutes as an unit under delay node',
  },
  {
    key: 'isMlbOrg',
    description: '',
  },
  {
    key: 'journeyBuilder',
    description: 'Journey Builder enabled',
  },
  {
    key: 'journeyMarveChat',
    description: 'Enable the Marve chat panel on the journey canvas',
    createdAt: '2026/08/05',
  },
  {
    key: 'joinConfigurationOnModelsPageEnabled',
    description: `
      Allow the user to set a join configuration between a dataset and a user trait (Model with User Trait type) directly on the Models page.
      This FF also hides the join key, as it is not required.
      Created at 2024/08/09'
    `,
    createdAt: '2024/08/09',
  },
  {
    key: 'cancelExport',
    description: 'Enable the ability to cancel in-progress exports',
    createdAt: '2025/09/18',
  },
  {
    key: 'retryExport',
    description: 'Enable the ability to retry failed exports',
    createdAt: '2025/09/18',
  },
  {
    key: 'removeOnNextDestination',
    description:
      'Show destination node setting for removing users when they reach another destination',
    createdAt: '2026/06/18',
  },
  {
    key: 'replaceLooker',
    description: 'Show the warehouse-backed audience size chart',
    createdAt: '2026/08/11',
  },
  {
    key: 'replaceLookerSourceCosts',
    description: 'Show warehouse-backed source cost reports',
    createdAt: '2026/09/08',
  },
  {
    key: 'frontendMixpanelAnalytics',
    description: 'Enable Mixpanel analytics on the frontend',
  },
  {
    key: 'httpDestination',
    description: 'Enable the HTTP destination in the create destination modal',
  },
  {
    key: 'fullAudienceRefreshEnabled',
    description: `
      Allows for the full audience to be sent to a destination for all destinations. Not just the delta in audience'
    `,
    createdAt: '2024/08/09',
  },
  {
    key: 'marveEnabled',
    description: 'Enable marve options on dataset group pages',
  },
  {
    key: 'showAllFieldCheckBoxes',
    description:
      'Show all field checkboxes on additional fields form and personalization multiselect form',
  },
  {
    key: 'kohlsAllFieldsButton',
    description:
      'Show button to add primary table fields on additional fields form',
  },
  {
    key: 'showAudienceScheduleOnDestinationNode',
    description: 'Enable user to configure audience export schedule',
  },
  {
    key: 'showExperiments',
    description: 'Experiment Node activated',
  },
  {
    key: 'showCRM',
    description: 'CRM Node activated',
  },
  {
    key: 'showExportDuration',
    description: '',
  },
  {
    key: 'showNestedMatchFields',
    description: 'Show Nested Match Fields Component',
  },
  {
    key: 'showReentry',
    description: 'Enable user reentry on journey',
  },
  {
    key: 'showReportingTooltip',
    description: 'tooltip for journeys metrics on report chips',
  },
  {
    key: 'showSimulate',
    description: '',
  },
  {
    key: 'showStepActivityTable',
    description: 'show step activity table',
    createdAt: '2024/04/24',
  },
  {
    key: 'audienceExportWritePermission',
    description: '',
  },
  {
    key: 'audienceTemplateWritePermission',
    description: '',
  },
  {
    key: 'chooseYourExportObject',
    description: 'allow user to select secondary dataset on audience export',
  },
  {
    key: 'hardResetJourney',
    description: 'Enable hard reset option on journeys',
  },
  {
    key: 'campaignTriggers',
    description: 'Can see Campaign Triggers fields',
    createdAt: '2024/12/10',
  },
  {
    key: 'canEditLockedTemplates',
    description: 'Can edit locked templates',
  },
  {
    key: 'pageViewTiming',
    description: 'Allows for NewRelic page view timing.',
  },
  {
    key: 'sessionTracing',
    description: 'Allows for NewRelic session tracing.',
  },
  {
    key: 'computedFieldsCustomAttributes',
    description: 'Add user traits to custom attributes',
    createdAt: '2024/10/31',
  },
  {
    key: 'journeysManualMode',
    description:
      'Enable manual mode for journeys, allowing users to manually trigger journey steps',
    createdAt: '2024/10/01',
  },
  {
    key: 'tableNameUniquenessCheck',
    description:
      'Enable validation to ensure table names are unique when configuring paid media exports',
    createdAt: '2024/12/11',
  },
  {
    key: 'realtimeJourneys',
    description: 'Enables realtime journeys',
    createdAt: '2025/01/27',
  },
  {
    key: 'realtimeJourneyCounters',
    description: 'Enables realtime journey counter custom attributes',
    createdAt: '2026/07/23',
  },
  {
    key: 'hybridJourneyRealtimeFields',
    description:
      'Show personalization-backed warehouse fields in realtime journey criteria',
    createdAt: '2026/04/05',
  },
  {
    key: 'resetUserConsent',
    description: 'Do not preselect the user consent field when exporting',
    createdAt: '2025/01/14',
  },
  {
    key: 'realtimeEvents',
    description: 'Enables realtime event sources.',
    createdAt: '2025/01/14',
  },
  {
    key: 'awsSqsSourceConnectionEnabled',
    description:
      'Enables AWS SQS source connection. (Requires realtimeEvents to be enabled.)',
    createdAt: '2025/08/22',
  },
  {
    key: 'spannerSourceConnectionEnabled',
    description: 'Enables Spanner source connection.',
    createdAt: '2026/05/27',
  },
  {
    key: 'ingestSources',
    description: 'Enable ingest connections (Easy Button) UI',
    createdAt: '2026/08/27',
  },
  {
    key: 'ingestDestinations',
    description: 'Allow to ingest destinations (link to an import source)',
    createdAt: '2025/01/19',
  },
  {
    key: 'loopTracker',
    description: 'Enable loop tracker',
    createdAt: '2025/03/06',
  },
  {
    key: 'showAIStudio',
    description: 'Enable AI Studio',
    createdAt: '2025/04/07',
  },
  {
    key: 'showNewJourneyBuilder',
    description: 'Enable new journey builder',
    createdAt: '2025/04/28',
  },
  {
    key: 'marketoCustomObject',
    description: 'Enable selection of Marketo custom objects',
    createdAt: '2025/05/23',
  },
  {
    key: 'notifyOnNullUniqueKey',
    description: 'Enable notification on null resolution',
    createdAt: '2025/05/13',
  },
  {
    key: 'organizationRedesign',
    description: 'Enable the redesigned organization management page',
    createdAt: '2026/05/27',
  },
  {
    key: 'public_api',
    description: 'Enable Public API credentials and endpoints',
  },
  {
    key: 'triggerNode',
    description: 'Enable trigger node in journey builder',
    createdAt: '2025/09/03',
  },
  {
    key: 'previewAudienceData',
    description: 'Enable preview audience data',
    createdAt: '2025/09/18',
  },
  {
    key: 'pubSubSourceConnectionEnabled',
    description:
      'Enable Pub Sub source connection. (Requires realtimeEvents to be enabled)',
    createdAt: '2025/10/03',
  },
  {
    key: 'audienceExperiments',
    description: 'Enable audience experiments UI',
    createdAt: '2025/12/03',
  },
  {
    key: 'useAirbyteForIngestion',
    description: 'Use Airbyte instead of Fivetran for data ingestion',
    createdAt: '2025/12/18',
  },
  {
    key: 'decisioningNode',
    description: 'Enable decisioning node in journey builder',
    createdAt: '2026/01/12',
  },
  {
    key: 'journeyUpliftGraph',
    description:
      'Enable significance experiment type and statistics results in journey experiment node',
    createdAt: '2026/04/28',
  },
  {
    key: 'waitForNode',
    description: 'Enable wait for node in journey builder',
    createdAt: '2026/06/03',
  },
  {
    key: 'uploadMediaBriefs',
    description: 'Enable uploading media/product briefs in Marve chat',
    createdAt: '2026/01/20',
  },
  {
    key: 'contentLibrary',
    description:
      'Enable Content Library — team-scoped content templates and media assets',
    createdAt: '2026/03/04',
  },
  {
    key: 'contextGraphExplorer',
    description: 'Enable the Causal Graph page',
    createdAt: '2026/07/24',
  },
  {
    key: 'criteria_node_config_redesign',
    description: 'Enable the React filter addition picker in criteria config',
    createdAt: '2026/08/07',
  },
  {
    key: 'reactSPALayout',
    description: 'Enables the React SPA layout',
    createdAt: '2026/04/16',
  },
  {
    key: 'showStudioToolCalls',
    description: 'Enable tool call details in AI Studio agent messages',
    createdAt: '2026/04/28',
  },
  {
    key: 'scheduledTasks',
    description: 'Enable AI Studio scheduled tasks UI',
    createdAt: '2026/08/27',
  },
  {
    key: 'governanceRules',
    description: 'Enable configured governance rule authoring',
    createdAt: '2026/08/30',
  },
] as const;

export type FeatureFlagKey = (typeof featureFlags)[number]['key'];

if (__DEV__) {
  const set = new Set<string>();
  for (const flag of featureFlags) {
    if (set.has(flag.key)) {
      console.warn(`Feature flag "${flag.key}" is duplicated`);
    }
    set.add(flag.key);
  }
}
